var render, staticRenderFns
import script from "./VuesticDropdown.vue?vue&type=script&lang=js"
export * from "./VuesticDropdown.vue?vue&type=script&lang=js"
import style0 from "./VuesticDropdown.vue?vue&type=style&index=0&id=0ba2fed2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba2fed2')) {
      api.createRecord('0ba2fed2', component.options)
    } else {
      api.reload('0ba2fed2', component.options)
    }
    
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-dropdown/VuesticDropdown.vue"
export default component.exports